import { render, staticRenderFns } from "./DynamicInsertForm.vue?vue&type=template&id=3c3e08b4&scoped=true&"
import script from "./DynamicInsertForm.vue?vue&type=script&lang=js&"
export * from "./DynamicInsertForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3e08b4",
  null
  
)

export default component.exports